import { BeforeNotifyHandler } from '@honeybadger-io/core/build/src/types';

/**
 * This gives us a quick solution to ignore certain Honeybadger errors reactively.
 * Anytime we see a Honeybader notice that we want to ignore, add a regex item that
 * matches the error to this array and add an inline comment linking to the notice.
 *
 * @see https://docs.honeybadger.io/lib/javascript/guides/reducing-noise/#ignoring-errors
 */
const ignoredHbNoticeMessages = [
  // Ignore errors from Chrome extensions
  /chrome-extension:/,
  // https://app.honeybadger.io/projects/99139/faults/84801994
  /Invalid login credentials/,
  /ReferenceError: Can't find variable: __firefox__/,
  /ReferenceError: Can't find variable: __gCrWeb/,
  /ResizeObserver loop completed/,
  // See: https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-865857552
  /UnhandledPromiseRejectionWarning: Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/,
  /window.ethereum/,
  /window.__firefox__/,
];

export const beforeNotifyHandler: BeforeNotifyHandler = (notice) => {
  if (
    notice &&
    ignoredHbNoticeMessages.some(
      (msg) => msg.test(notice.stack) || msg.test(notice.message),
    )
  ) {
    return false;
  }
};
